
export default {
  name: 'Pagination',
  props: {
    lastPage: {
      type: Number,
      required: true,
    },
    linkBase: {
      type: String,
      default: '',
    },
    pageParam: {
      type: String,
      default: 'page',
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      disabled: true,
    };
  },
  computed: {
    previousPage() {
      return this.currentPage > 1 ? this.currentPage - 1 : 1;
    },
    nextPage() {
      return this.currentPage < this.lastPage ? this.currentPage + 1 : this.lastPage;
    },
    pages() {
      let start = this.currentPage - 2;
      if (start > this.lastPage - 4) {
        start = this.lastPage - 4;
      }
      if (start < 1) {
        start = 1;
      }
      const count = start + 5 > this.lastPage ? this.lastPage - start + 1 : 5;
      return Array.apply(0, Array(count)).map((_e, i) => {
        return i + start;
      });
    },
  },
  methods: {
    getLinkHref(page) {
      if (page <= 1 || page > this.lastPage) {
        return this.linkBase
      }

      return this.linkBase ? `${this.linkBase}?${this.pageParam}=${page}` : ''
    },
    handlePageSelected(selected) {
      this.$emit('pageSelected', selected)
    },
  },
};
